export default __webpack_public_path__ + "static/media/no-subscribed-bundles.2f135bdd.png";